module.exports = __webpack_public_path__ + "img/DHL_Logo.429f90f2.svg";